export class ProdutoUso {
    constructor(
        public corHex: string,
        public produtoDescricao: string,
        public valorGasto: number,
        public porcentagemGasto: number
    ) {}
}
